import { SWRConfiguration } from 'swr';

import { getToken } from '@helpers/auth';
import { useRequest } from '@helpers/use';
import { swrImmutableOptions } from '@helpers/utils';
import { IUserIDSProfile } from '@interfaces/user';
import userAPI, { USER_END_POINT } from 'src/api/user';

export const useIdsProfile = (options?: SWRConfiguration) => {
  const hasAccessToken = getToken();
  const { data: idsProfile, isLoading, isValidating, mutate } = useRequest<IUserIDSProfile>(
    hasAccessToken ? USER_END_POINT.IDS_USER : null,
    userAPI.fetchIdsProfile,
    { ...options, ...swrImmutableOptions },
  );
  return {
    idsProfile,
    isLoading,
    isValidating,
    mutate,
  };
};
